import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { PackType } from '../../../../redux/userStore/reducer';
import { ORANGE } from '../../../../shared/colors';
import { getPack, updatePack } from '../../../dashboard/network';

const FormShell = styled.div`
  color: var(--mt-text);

  .form-intro {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 14px;
    background: var(--mt-surface);
  }

  .form-intro span {
    color: var(--mt-warning);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-intro h3 {
    margin: 5px 0 0;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .ant-form-item-label label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 12px;
    text-transform: uppercase;
  }

  .ant-input {
    height: 42px;
    border-color: var(--mt-border);
    border-radius: 8px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .submit-button {
    min-width: 180px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, #ffb000);
    color: #07141c;
    font-family: Poppins-B;
  }
`;

export const PackUpdateForm = ({
  setShowDrawer,
  setthepack,
  getNewPack,
}: {
  setShowDrawer: (b: boolean) => void;
  setthepack: PackType;
  getNewPack: (part: PackType[]) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  // const connectedUser = new ConnectedUserEntity(
  //   useSelector((state: any) => state.userReducer).user,
  // );
  form.setFieldsValue(setthepack);
  return (
    <FormShell>
      <div className='form-intro'>
        <span>Modification pack</span>
        <h3>{setthepack?.nom}</h3>
      </div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        initialValues={setthepack}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          await updatePack(setthepack.id, data).then(({ statusCode, data }) => {
            if (statusCode.toString()[0] === '2') {
              notification.success({
                message: 'Pack mis à jour',
                description: 'Votre pack a été mis à jour avec succès',
              });
              // afficher le statuts des matchs
              getPack().then(({ data }) => {
                getNewPack(data);
              });
            } else {
              notification.error({
                message: 'Erreur',
                description: data.message,
              });
            }
            setIsLoading(false);
            setShowDrawer(false);
          });
        }}
      >
        <Form.Item
          label='Nom du pack'
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le nom du pack',
            },
          ]}
        >
          <Input placeholder='Entrez le nom du pack' value='2' />
        </Form.Item>
        <Form.Item
          label='Cout du pack'
          name='amount'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le montant du pack',
            },
          ]}
        >
          <Input
            placeholder='Entrez la montant'
            type='number'
            value={setthepack?.amount}
            min={0}
          />
        </Form.Item>
        <Form.Item
          label='Durée du pack (En année)'
          name='duree_an'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la durée du pack',
            },
          ]}
        >
          <Input
            placeholder='Entrez la durée'
            type='number'
            value={setthepack?.duree_an}
            min={0}
          />
        </Form.Item>
        <Form.Item>
          <Button
            className='submit-button'
            htmlType='submit'
            loading={isLoading}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </FormShell>
  );
};
